module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/286.83d0767f.png";